import { StyleSheet } from 'react-native-unistyles';

export const styles = StyleSheet.create((colors) => ({
  card: {
    backgroundColor: 'transparent',
    borderWidth: 1,
    borderColor: colors.cartBorder,
  },
}));
